import { Points } from "three";
/**
 * Points which can update its decoration
 */
export class ScanPoints extends Points {
    constructor(geom, _sa) {
        super(geom, _sa.getMaterial());
        this._sa = _sa;
    }
    updateDecoration(deco) {
        this._sa.updateShader(this.geometry, deco);
    }
}
//# sourceMappingURL=ScanPoints.js.map